// extracted by mini-css-extract-plugin
export var fullWidthButton = "_py-0";